<template>
  <v-col cols="12" md="3">
    <v-row>
      <v-col cols="12">
        <v-card
          color="#F1F1F1"
          flat
          :style="{
            borderRadius: '15px',
          }"
        >
          <v-card-title>Patient Information</v-card-title>
          <v-card-text>
            <v-tabs v-model="patientInformationTab" background-color="#F1F1F1">
              <template v-for="(tab, index) in patientInformationTabs">
                <v-tab :key="index" class="text-capitalize">{{ tab }}</v-tab>
              </template>
            </v-tabs>
          </v-card-text>
          <v-card-text>
            <v-tabs-items v-model="patientInformationTab" class="transparent">
              <v-tab-item
                :style="{
                  height: '650px',
                  overflow: 'auto',
                }"
              >
                <div
                  class="fill-height d-flex justify-center align-center"
                  v-if="isGetPatientInformationStart"
                >
                  <v-progress-circular
                    color="grey"
                    width="3"
                    indeterminate
                  ></v-progress-circular>
                </div>
                <div v-if="patientInformation && !isGetPatientInformationStart">
                  <table class="table table-striped table-bordered">
                    <tbody>
                      <tr>
                        <th>Name:</th>
                        <td>
                          <a target="_blank" v-if="patientInformation.patient.pms_guid" :href="`${baseDomain}/patient/information/patient_update/${patientInformation.patient.pms_guid}`">{{formatName(patientInformation)}}</a>
                          <span v-if="!patientInformation.patient.pms_guid">{{formatName(patientInformation)}}</span>

                          <div v-if="patientInformation.patient.pms_guid" id="patient-action-wrapper">
                            <a target="_blank" :href="`${baseDomain}/case/consultations/consultation_history/${patientInformation.patient.pms_guid}`" class="btn btn-primary patient-instance-action">Cases</a>
                            <a target="_blank" :href="`${baseDomain}/inquiries/patient_history/${patientInformation.patient.pms_guid}`" class="btn btn-info patient-instance-action">Inquiries</a>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th>Birthdate</th>
                        <td>{{ formatDateTime(patientInformation.patient.birthdate, true) || "N/A" }}</td>
                      </tr>

                      <tr>
                        <th>Gender</th>
                        <td>{{ patientInformation.patient.gender || "N/A" }}</td>
                      </tr>

                      <tr>
                        <th>Civil Status</th>
                        <td>{{ patientInformation.patient.marital_status || "N/A" }}</td>
                      </tr>

                      <tr>
                        <th>Provider</th>
                        <td>{{ getInsuranceProviderName(patientInformation) || 'N/A' }}</td>
                      </tr>

                      <tr>
                        <th>Provider Number</th>
                        <td>{{ getInsuranceProviderNumber(patientInformation) }}</td>
                      </tr>

                      <tr>
                        <th>Email</th>
                        <td>{{ patientInformation.email || "N/A" }}</td>
                      </tr>

                      <tr>
                        <th>Alternate Email</th>
                        <td>{{ patientInformation.patient.alternate_email || "N/A" }}</td>
                      </tr>

                      <tr>
                        <th>Mobile Number</th>
                        <td>{{ patientInformation.patient.mobile_number || "N/A" }}</td>
                      </tr>
                    </tbody>
                  </table>   
                </div>
              </v-tab-item>
              <v-tab-item
                :style="{
                  height: '650px',
                  overflow: 'auto',
                }"
              >
                <div
                  class="fill-height d-flex justify-center align-center"
                  v-if="patientCases.length === 0 && !isGetPatientCasesStart"
                >
                  <span class="subtitle-2 font-italic">No data available.</span>
                </div>
                <div
                  class="fill-height d-flex justify-center align-center"
                  v-if="isGetPatientCasesStart"
                >
                  <v-progress-circular
                    color="grey"
                    width="3"
                    indeterminate
                  ></v-progress-circular>
                </div>
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Case No</th>
                      <th>Date</th> 
                    </tr>                    
                  </thead>
                  <template v-for="(item, index) in patientCases">
                      
                    <tr :key="index">
                      <td>
                        <a target="_blank" v-if="item.consultations[0]" :href="`${baseDomain}/case/consultations/${item.consultations[0].id}`">
                          {{ item.case_number }}
                        </a>
                        <span v-else>{{ item.case_number }}</span>
                      </td>
                      <td>{{formatDateTime(item.created_at)}}</td> 
                    </tr>                    

                  </template>
                </table>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import moment from 'moment';
export default {
    name: 'PatientInformation',
    props: ['patientInformation', 'isGetPatientInformationStart', 'patientCases', 'isGetPatientCasesStart'],
    data () {
        return {
            patientInformationTabs: ["General", "Case"],
            patientInformationTab: null,
            baseDomain: process.env.VUE_APP_API_URL,
        }
    },

    methods: {
        formatDateTime(dateTime, date = false) {
            let stringFormat = !date ? 'l [at] h:mmA' : 'YYYY-MM-DD';
            return dateTime ? moment(dateTime).format(stringFormat) : "";
        },

        formatName(user) {
          let name = null;
          let firstName = user.patient.first_name;
          let lastName = user.patient.last_name;

          if (user.patient.full_name != null && user.patient.full_name.trim() != '') {
            name = user.patient.full_name.trim();
          } else if (firstName && lastName) {
            name = `${firstName} ${lastName}`;
          } else if (firstName && !lastName) {
            name = `${firstName}`;
          } else if (!firstName && lastName) {
            name = `${lastName}`;
          } else {
            name = user.username || user.email;
          }

          return name;
        },

        getInsuranceProviderName (patient) {
          let providerName = 'N/A';
          if (patient.insurance_provider != '') {
            providerName = patient.insurance_provider;
          } else if (patient.user_providers.length > 0) {
            let userProvider = patient.user_providers[0];
            providerName = userProvider.provider_name;
          }
          return providerName;
        },

        getInsuranceProviderNumber (patient) {
          let providerNumber = 'N/A';
          if (patient.insurance_number != '') {
            providerNumber = patient.insurance_number;
          } else if (patient.user_providers.length > 0) {
            let userProvider = patient.user_providers[0];
            providerNumber = userProvider.provider_number;
          }
          return providerNumber;
        }
    },
    
}
</script>